import { api } from "./api";

const proserviceApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getProServices: builder.query({
      query: () => "/all_pro_service",
      providesTags: ["pro-service"],
    }),
    getProServiceById: builder.query({
      query: (id) => `/pro_service_by_id/${id}`,
      providesTags: ["pro-service"],
    }),
    addProService: builder.mutation({
      query: (newData) => ({
        url: "/create_pro_service",
        method: "POST",
        body: newData,
      }),
      invalidatesTags: ["pro-service"],
    }),
    removeProService: builder.mutation({
      query: (id) => ({
        url: `pro-service/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["pro-service"],
    }),
    editProService: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/pro-service/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["pro-service"],
    }),
    updateProService: builder.mutation({
      query: ({ id, ...editData }) => ({
        url: `/update_pro_service/${id}`,
        method: "PATCH",
        body: editData,
      }),
      invalidatesTags: ["pro-service"],
    }),
  }),
});

export const {
  useGetProServicesQuery,
  useGetProServiceByIdQuery,
  useAddProServiceMutation,
  useRemoveProServiceMutation,
  useEditProServiceMutation,
  useUpdateProServiceMutation,
} = proserviceApi;
